import { array } from 'fp-ts';
import { LocalizedCurrencyValue, LocalizedText } from '@mews/framework';
import { WithBillId } from '@mews-commander/types';
import { Stack, StackItem } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { UnicodeEntity } from '@mews/enums';
import { useCorrectionDetail } from '../../hooks/useCorrectionDetail';

export const CorrectionBillTotalRow = ({ billId }: WithBillId) => {
    const { data } = useCorrectionDetail({ correctionBillId: billId });
    const { correctiveOrderItems, correctiveBill } = data || {};

    if (!correctiveOrderItems || array.isEmpty(correctiveOrderItems)) return null;

    return (
        <Stack fill distribution="space-between">
            <StackItem padding="200">
                <LocalizedText textKey={TextKey.AmountChange} />
                {UnicodeEntity.Colon}
            </StackItem>
            <StackItem padding="200">
                {correctiveBill?.totalAmount && <LocalizedCurrencyValue value={correctiveBill.totalAmount} />}
            </StackItem>
        </Stack>
    );
};
